<template>
  <div class="section debug-grid" :class="classes" v-if="!none">
    <div class="debug-grid__content-wrapper">
      <div class="grid-row">
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      <div class="grid-block"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'debug-grid',
  props: {
    top: {
      type: Boolean,
    },
    bottom: {
      type: Boolean,
    },
    full: {
      type: Boolean,
    }
  },
  computed: {
    none() {
      return !this.top && !this.botom && !this.full;
    },
    classes() {
      const classes = [];

      if (this.top) {
        classes.push('debug-grid--top');
      }
      if (this.bottom) {
        classes.push('debug-grid--bottom');
      }
      if (this.full) {
        classes.push('debug-grid--full');
      }
      if (this.none) {
        classes.push('debug-grid--hidden');
      }

      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.debug-grid {
  &--hidden {
    display: none;
  }
  position: fixed;
  width: 100%;
  z-index: $z-index-debug;
  opacity: 0.4;
  min-height: 5rem;
  pointer-events: none;

  &--top {
    top: 0;
  }
  &--bottom {
    bottom: 0;
  }
  &--full {
    top: 0;
    bottom: 0;
  }
  &__content-wrapper,
  .grid-block,
  .grid-row {
    height: 100%;
  }
  &__content-wrapper {
    @include grid-container;
  }
}

  .grid-block {
    background: $color-base-black-base;
    float: left;
    &::before {
      width: 100%;
      background: $color-base-red-bull-blue-base;
      // border: 1px solid $color-base-ninja-light-blue-base;
      content: '';
      height: 100%;
      display: block;
    }

    @include grid-block($columns: 1, $small-columns: 1);
    @include grid-block-margin();
    @include global-media(small) {
      &:nth-child(n+5) {
        display: none;
      }
      &:nth-child(4) {
        padding-right: 0;
      }
    }
  }
  .grid-row {
    overflow: hidden;
    @include grid-row();
  }
</style>
